

// interface ModalTelaProduto { }

import { ref, onMounted, onUnmounted, defineEmits, watch, Ref, onBeforeMount, DefineComponent } from "vue";
import { defineComponent } from "vue";
import Api from "../../services/Api";
import s3 from '../../services/S3Service'
import useAlert from "../../composables/Alert";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import ModalTelaProduto from "./components/ModalTelaProduto.vue";
import ModalUploadProdutos from "./components/ModalUploadProdutos.vue";
import Title from "@/components/Title.vue";
import Button from "@/components/Button.vue";
import { useLoaderStore } from "@/store/LoaderStore";
import { Modal } from "bootstrap";
import * as XLSX from 'xlsx/xlsx.mjs';
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
import { TypeOf } from "yup";


export default defineComponent({
  components: { 
    ModalTelaProduto,
    ModalUploadProdutos, 
    Title,
    Button,
    Pagination
  },
  name: "Produtos",

  setup() {

    const { showTimeAlert } = useAlert();
    const auxModal: Ref<any> = ref('');
    const arquivo: Ref<any> = ref();
    const router = useRouter();
    const route = useRoute();
    const idLoja: Ref<any> = ref(null);
    const produtos: Ref<any> = ref([])
    const loja: Ref<any> = ref([])
    const filteredProducts: Ref<any> = ref([]);
    const productsToUpload: Ref<any> = ref([]);
    const loaderStore = useLoaderStore();
    // const productsToVerify: Ref<any> = ref([]);
    const inputFind: Ref<string> = ref('');
    const fileInput: Ref<any> = ref(null);
    const produto: Ref<any> = ref({})
    const paramsProdutos: Ref<any> = ref({ pagina: 1, limite: 10, input: ''})
    const isHomologado: Ref<boolean> = ref(true)
    const openFind: Ref<boolean> = ref(false)
    const findActive: Ref<boolean> = ref(false)
    const totalProdutos: Ref<number> = ref(0)
    const isLoading: Ref<boolean> = ref(false)
    const page: Ref<number> = ref(1);
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);
    
    function catchIdParams() {
      idLoja.value = route.query.storeId;
    }

    const openModal = id => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();
    };

    function closeModal() {
      auxModal.value.hide()
    }

    const getToken = async () => {
      return localStorage.getItem("token_usuario");
    };
    getToken();

    function buscarProduto(product: Object | null = null) {
      if (!product) {
        openModal('modalTelaProduto')
        return produto.value = {
          codConcessionaria: idLoja.value,
        }
      }
      produto.value = product
      openModal('modalTelaProduto')
    }

    async function getProdutosLoja() {
      try {
        isLoading.value = true
        const { data } = await axios.post("produtoPaginadoGestao", { ...paramsProdutos.value, idLoja: idLoja.value }, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
            idLoja: idLoja.value
          },
        });

        loja.value = data.loja;

        switch (isHomologado.value) {
          case true:
            produtos.value = data.homologados;
            totalProdutos.value = data.totalHomologados;
            break;
          case false:
            produtos.value = data.naoHomologados;
            totalProdutos.value = data.totalNaoHomologados;
            break;
        }

      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false
      }
    }

    async function downloadProducts() {
      try {
        const res = await Api.get('baixarPlanilhaProdutos', {idLoja: idLoja.value},{ responseType: 'blob' })
        
        const nomeLoja = loja.value.nomeFantasia.toLowerCase().replaceAll(' ', '_')

        const hoje = new Date();
        const dataFormatada = hoje.toISOString().replaceAll('-', '_').split('T')[0];

        baixaArquivo(res, `meus_produtos_${nomeLoja}_${dataFormatada}.xlsx`)
      } catch (err) {
        console.log(err);
      }
    }

    function baixaArquivo(blobParam:any, name:string) {

      const url = URL.createObjectURL(new Blob([blobParam]));
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      link.click();
      URL.revokeObjectURL(url);
    }

    const openInput = () => fileInput.value.click();

    const uploadProducts = async (event: any) => {
      const file = event.target.files[0];
      arquivo.value = file;
      getJsonFromXLSX()
    };

    async function getJsonFromXLSX() {
      if(arquivo.value){
        const fileReader = new FileReader();
        fileReader.onload = function(event){
          const data = event.target?.result;

          const workbook = XLSX.read(data, {
            type: "binary"
          });
          workbook.SheetNames.forEach(sheet => {
            let rowObject = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheet]
            );
            let jsonObject = JSON.stringify(rowObject);
            productsToUpload.value = JSON.parse(jsonObject)
          })
        }
        fileReader.readAsBinaryString(arquivo.value)
        openModal('modalUploadProdutos')
        loaderStore.open();
      }
    }

    function filterProd(str: string) {
      filteredProducts.value = produtos.value.filter(objeto => {
        return Object.entries(objeto).some(([chave, valor]) => {
          if (typeof valor === 'string' && valor.includes(str)) {
            return true;
          }
          return false;
        });
      });
    }
   
    function getNaoHomologados(){
      isHomologado.value = !isHomologado.value;
      paramsProdutos.value.pagina = page.value;
      if (pagination.value) {
        pagination.value.resetPage(1);
      } 
      getProdutosLoja(); 
    }

    function handlePageChange(pageParam) {
      paramsProdutos.value.pagina = pageParam;
      getProdutosLoja();
    }


    watch(
      () => idLoja.value,
      () => getProdutosLoja()
    )
  
    watch(
      () => paramsProdutos.value.pagina,
      () => { getProdutosLoja() }
    )

    onBeforeMount(() => catchIdParams());

    return {
      router,
      route,
      produtos,
      inputFind,
      filterProd,
      filteredProducts,
      openModal,
      buscarProduto,
      produto,
      getProdutosLoja,
      auxModal,
      closeModal,
      idLoja,
      paramsProdutos,
      //paginar,
      openFind,
      totalProdutos,
      findActive,
      fileInput,
      downloadProducts,
      openInput,
      uploadProducts,
      productsToUpload,
      isLoading,
      getNaoHomologados,
      isHomologado,
      handlePageChange,
      page,
      pagination
    };
  },
});
